// extracted by mini-css-extract-plugin
module.exports = {"category":"X_dW","wrapp":"X_dX","category__wrapper":"X_dY"};